var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "button",
    {
      staticClass: "btn btn--primary",
      class: { "btn--loading": _vm.loading },
      on: {
        click: function($event) {
          $event.preventDefault()
          return _vm.$emit("click")
        }
      }
    },
    [
      _vm.loading
        ? _c("span", { staticClass: "btn__loader" }, [_c("gc-loader")], 1)
        : _vm._e(),
      _vm._v(" "),
      _c("span", {
        staticClass: "btn__text",
        domProps: { textContent: _vm._s(_vm.label) }
      })
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }